const SELECT_THEME = 'SELECT_THEME';
const SELECT_LOCALE = 'SELECT_LOCALE';
const DRAWER_ON = 'DRAWER_ON';
const DRAWER_OFF = 'DRAWER_OFF';
const MOBILE_DRAWER_ON = 'MOBILE_DRAWER_ON';
const MOBILE_DRAWER_OFF = 'MOBILE_DRAWER_OFF';
const WORK_STATUS_DRAWER_ON = 'WORK_STATUS_DRAWER_ON';
const WORK_STATUS_DRAWER_OFF = 'WORK_STATUS_DRAWER_OFF';
const OUTPUT_DRAWER_ON = 'OUTPUT_DRAWER_ON';
const OUTPUT_DRAWER_OFF = 'OUTPUT_DRAWER_OFF';
const IMPORT_DRAWER_ON = 'IMPORT_DRAWER_ON';
const IMPORT_DRAWER_OFF = 'IMPORT_DRAWER_OFF';
const MAINTENANCE_DRAWER_ON = 'MAINTENANCE_DRAWER_ON';
const MAINTENANCE_DRAWER_OFF = 'MAINTENANCE_DRAWER_OFF';

export default {
  SELECT_THEME,
  SELECT_LOCALE,
  DRAWER_ON,
  DRAWER_OFF,
  MOBILE_DRAWER_ON,
  MOBILE_DRAWER_OFF,
  WORK_STATUS_DRAWER_ON,
  WORK_STATUS_DRAWER_OFF,
  OUTPUT_DRAWER_ON,
  OUTPUT_DRAWER_OFF,
  IMPORT_DRAWER_ON,
  IMPORT_DRAWER_OFF,
  MAINTENANCE_DRAWER_ON,
  MAINTENANCE_DRAWER_OFF,
};
